import type { NotificationEventSeverity } from "./notification-event";

export const RISKFLOW_TOAST_SCORE_THRESHOLD = 6.5;

const RISKFLOW_CATEGORIES = new Set([
  "riskflow",
  "geopolitical_alerts",
  "econ_alerts",
]);

export interface RiskFlowScoreInput {
  score?: unknown;
  ivScore?: unknown;
  metadata?: Record<string, unknown>;
}

function finiteNumber(value: unknown) {
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (typeof value === "string" && value.trim()) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}

export function normalizedRiskFlowScore(input: RiskFlowScoreInput) {
  const metadata = input.metadata ?? {};
  const candidates = [
    input.score,
    input.ivScore,
    metadata.normalizedScore,
    metadata.score,
    metadata.ivScore,
    metadata.headlineWeight,
    metadata.headlineIvScore,
    metadata.headlineEventWeight,
  ];
  for (const candidate of candidates) {
    const score = finiteNumber(candidate);
    if (score !== null) return score;
  }
  return null;
}

export function isRiskFlowCategory(category: string) {
  return RISKFLOW_CATEGORIES.has(category);
}

export function isRiskFlowToastEligible(input: RiskFlowScoreInput) {
  const score = normalizedRiskFlowScore(input);
  return score !== null && score >= RISKFLOW_TOAST_SCORE_THRESHOLD;
}

export function notificationSeverity(
  value: unknown,
): NotificationEventSeverity {
  if (value === "critical") return "critical";
  if (value === "high" || value === "warning") return "warning";
  if (value === "error") return "error";
  if (value === "success") return "success";
  if (value === "low" || value === "medium" || value === "info") return "info";
  return "neutral";
}
